import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../../../config/api';
import SmtpSettingsCard from './SmtpSettingsCard';
import ComposeEmailCard from './ComposeEmailCard';

const API = `${API_BASE}/api`;
const STATUS = { sending: 'text-sky-300', completed: 'text-emerald-300', partial: 'text-amber-300', failed: 'text-rose-300' };
const audienceLabel = (e) => (e.audience === 'all' ? 'All users' : e.audience === 'cohorts' ? (e.cohort_names || []).join(', ') : 'Selected users');

export default function EmailAdmin({ token }) {
  const headers = { Authorization: `Bearer ${token}` };
  const [log, setLog] = useState([]);

  const loadLog = useCallback(() => {
    axios.get(`${API}/admin/email/log`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setLog(r.data.emails || [])).catch(() => {});
  }, [token]);
  useEffect(() => {
    loadLog();
    const t = setInterval(loadLog, 8000);
    return () => clearInterval(t);
  }, [loadLog]);

  return (
    <div className="p-8 space-y-8" data-testid="email-admin">
      <div>
        <h1 className="font-heading text-3xl font-bold text-white mb-1">Email</h1>
        <p className="text-sm text-zinc-400">Connect your mail server, then email users and cohorts. Invites, emailed announcements and instructor question alerts use these settings too.</p>
      </div>
      <div className="grid xl:grid-cols-2 gap-6 items-start">
        <SmtpSettingsCard headers={headers} />
        <ComposeEmailCard headers={headers} onSent={loadLog} />
      </div>
      <div>
        <h2 className="text-lg font-semibold text-white mb-3">Sent emails</h2>
        <div className="bg-navigate-surface border border-zinc-800 rounded-xl overflow-x-auto">
          <table className="w-full text-sm" data-testid="email-log-table">
            <thead className="bg-zinc-800/50"><tr>
              {['Subject', 'Date', 'Audience', 'Source', 'Delivered', 'Status'].map((h) => <th key={h} className="px-5 py-3 text-left text-xs font-medium text-zinc-400 uppercase">{h}</th>)}
            </tr></thead>
            <tbody className="divide-y divide-zinc-800">
              {log.length === 0 ? <tr><td colSpan={6} className="px-5 py-10 text-center text-zinc-500" data-testid="email-log-empty">No emails sent yet.</td></tr>
                : log.map((e) => (
                  <tr key={e.email_id} data-testid={`email-log-row-${e.email_id}`}>
                    <td className="px-5 py-3 text-white">{e.subject}</td>
                    <td className="px-5 py-3 text-zinc-300 whitespace-nowrap">{new Date(e.created_at).toLocaleString('en-ZA', { dateStyle: 'medium', timeStyle: 'short' })}</td>
                    <td className="px-5 py-3 text-zinc-300">{audienceLabel(e)}</td>
                    <td className="px-5 py-3 text-zinc-400 capitalize">{e.source}</td>
                    <td className="px-5 py-3 text-zinc-300">{e.sent}/{e.recipient_count}{e.failed ? <span className="text-rose-300"> · {e.failed} failed</span> : ''}{e.last_error && <p className="text-[11px] text-rose-300/80 max-w-xs truncate" title={e.last_error} data-testid={`email-log-error-${e.email_id}`}>{e.last_error}</p>}</td>
                    <td className={`px-5 py-3 capitalize ${STATUS[e.status] || 'text-zinc-300'}`}>{e.status}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
